module.exports = __webpack_public_path__ + "static/media/spec_diet.81d9aea0.png";